import { useEffect, useState } from "react";
import { OrderModel } from "../../data/models/order/OrderModel";

export function useOrdersByDate(
  fetchOrders: (from: string, to: string) => Promise<OrderModel[] | undefined>
) {
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [orders, setOrders] = useState<OrderModel[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const now = new Date();

    const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0);

    const endOfToday = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      23,
      59
    );

    setFrom(formatForInput(startOfMonth));
    setTo(formatForInput(endOfToday));
  }, []);

  const search = async () => {
    if (!from || !to) return;

    setLoading(true);
    try {
      const data = await fetchOrders(from, to);
      setOrders(data ?? []);
    } finally {
      setLoading(false);
    }
  };

  return {
    from,
    to,
    setFrom,
    setTo,
    orders,
    loading,
    search,
  };
}

function formatForInput(date: Date): string {
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
    date.getDate()
  )}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}
